import {NgModule, ModuleWithProviders } from '@angular/core';
import {AuthService} from './auth/auth.service';
import {AuthGuard} from './auth/auth-guard.service';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';




@NgModule({
  imports: [
      CommonModule,
      HttpClientModule
  ],
  providers: [
    AuthService,
    AuthGuard
  ]
})
export class ServiceModule {

}
